const patientsStore = {
  state: {
    allPatients: [],
  },
  reducers: {
    SET_ALL_PATIENTS: (state, allPatients) => ({
      ...state,
      allPatients,
    }),
  },
  //   effects: (dispatch) => ({
  //     async incrementAsync(payload, state) {
  //       await new Promise((resolve) => setTimeout(resolve, 1000));
  //       dispatch.counter.increment(payload);
  //     },
  //   }),
};

export default patientsStore;
